// tslint:disable-next-line: import-spacing
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthServiceProvider } from '../users/auth-service/auth-service';
import { Authentication, AdalConfig, User } from 'adal-ts';
import { UserDecoder } from './user.decoder';
import { Storage } from '@ionic/storage';
import { SimpleIndexedDBService } from '../services/simple-indexeddb.service';
import { UserData } from '../users/user-data';
import { AppComponent } from '../app.component';
import { RolePermissionsService } from '../users/rolepermissions-service/rolepermissions-service';
import { ModalController } from '@ionic/angular';
import { UserAgencyComponent } from '../user-agency/user-agency.component';
import { AgencyDetailsService } from '../agency-details/agency-details.service';
import { LoadingController } from '@ionic/angular';
import { StaffService } from '../staff/staff.service';
import { UserProfileService } from '../users/user-profile';
import { UserProfileStorageService } from '../services/user-profile-storage.service';

@Component({
  selector: 'app-auth-callback',
  template: '<div><h3></h3></div>'
})

export class AuthCallbackComponent implements OnInit {

  public message: string;
  user: User;
  appComponent: AppComponent;
  indicator: HTMLIonLoadingElement = null;
  requestsQueue: Array<any> = [];
  constructor(
    private authService: AuthServiceProvider,
    private router: Router,
    private indexedDB: SimpleIndexedDBService,
    public userData: UserData,
    public agencyDetailsService: AgencyDetailsService,
    public staffService: StaffService,
    public modalController: ModalController,
    private rolePermissionsService: RolePermissionsService,
    private loading: LoadingController,
    private userProfileService: UserProfileService,
    private userProfileStorage: UserProfileStorageService
  ) { }

  async ngOnInit() {
    try {
      this.showLoader();

      const context = Authentication.getContext(this.authService.createConfig());
      this.user = context.getUser();
      console.log('auth--- USER', this.user);

      const params = this.parseQueryString(location.hash);
      console.log('auth--- Params in Auth Callback', params);
      if (params['id_token']) {
        this.user = new UserDecoder().decode(params['id_token']);
        console.log(this.user);
      }

      await this.indexedDB.setItem('idToken', params['id_token']);

      await this.userData.login(this.user.unique_name);
      const agencies = this.extractAgencyDetails(this.user);

      if (agencies.length > 1) {
        await this.handleMultipleAgencies();
      } else {
        await this.handleSingleAgency(JSON.parse(agencies[0]).Id);
      }
    } catch (error) {
      console.error('Error during auth init', error);
      this.router.navigate(['/errors', 0, '500']);
    } finally {
      this.hideLoader();
    }
  }

  private extractUniqueAgencies(user: any): number[] {
    const agencyData = user['http://net.lausd.btb/agencyId'];
    const agencies = Array.isArray(agencyData) ? agencyData : [agencyData];
    return [...new Set(agencies.map(Number))];
  }

  private extractAgencyDetails(user: any): any[] {
    const agencyData = user['http://net.lausd.btb/agencies'];
    const agencies = Array.isArray(agencyData) ? agencyData : [agencyData];
    return agencies;
  }

  private extractAgencyRolesMap(user: any): number[] {
    const agencyData = user['http://net.lausd.btb/agencyRoles'];
    const agencyRoles = Array.isArray(agencyData) ? agencyData : [agencyData];
    return agencyRoles;
  }

  private async handleMultipleAgencies() {
    const userAgencies = this.extractAgencyDetails(this.user);
    const roles = this.extractAgencyRolesMap(this.user);

    const modal = await this.modalController.create({
      component: UserAgencyComponent,
      componentProps: { userName: this.user.unique_name, userAgencies: userAgencies, roles: roles},
      backdropDismiss: false
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data && data.agencyId) {
      const userData = this.buildUserData(data.agencyId, data.role);
      await this.finalizeLogin(userData);
    }
  }

  private async handleSingleAgency(agencyId: number) {
    if (!agencyId || agencyId <= 0) {
      this.router.navigate(['/errors', 1, '401']);
      return;
    }

    await this.indexedDB.setItem('selectedAgencyId', agencyId);

    this.agencyDetailsService.getAgencyDetails(agencyId).subscribe(async (data) => {
      const agencyRole = this.extractAgencyRolesMap(this.user);
      const parsed = JSON.parse(agencyRole[0].toString());
      const roleId = Number(parsed.Role);

      //debugger;
      const userData = this.buildUserData(agencyId, roleId, data.name);

      const staff = await this.staffService.getStaffByLoginName().toPromise();
      if (!staff) {
        this.router.navigate(['/errors', 3, userData.agencyName]);
      } else {
        await this.finalizeLogin(userData);
      }
    });
  }

  private getRoleIdForAgency(agencyId: number): number {
    const agencies = this.extractUniqueAgencies(this.user);
    const index = agencies.findIndex(a => a === agencyId);
    return Number(this.user['role'][index]);
  }

  private buildUserData(agencyId: number, role: number, agencyName?: string) {
    return {
      name: this.user.unique_name,
      roles: [role],
      agency: agencyId,
      agencyName
    };
  }

  private async finalizeLogin(userData: any) {
    await this.userProfileService.getSecondaryToken(userData);

    // Save user profile directly to IndexedDB via UserProfileStorageService
    await this.userProfileStorage.updateProfile(userData);

    window.dispatchEvent(new CustomEvent('user:login'));
    const profile = this.userProfileStorage.profile;
    if (profile && profile.roles && profile.roles.includes(9)) {
      this.router.navigate(['/errors', 2, '403']);
    } else {
      window.location.href = '/schools';
    }
  }

  private parseQueryString(url: string): { [key: string]: string } {
    const params: { [key: string]: string } = {};
    const queryString = url.substring(1);
    const regex = /([^&=]+)=([^&]*)/g;

    let match;
    while ((match = regex.exec(queryString))) {
      const key = decodeURIComponent(match[1]);
      const value = decodeURIComponent(match[2]);
      params[key] = value;
    }

    return params;
  };

  showLoader() {
    if (this.indicator == null) {
      this.indicator = {} as HTMLIonLoadingElement;
      if (this.requestsQueue.length == 0) {
        this.loading
          .create({
            message: 'Please wait...',
            duration: 2000,
          })
          .then((res) => {
            this.indicator = res;
            res.present();
          });
      }
    }
  }

  hideLoader() {
    this.requestsQueue.pop();
    if (this.requestsQueue.length == 0) {
      if (this.indicator != null || this.indicator != undefined) {
        if (this.indicator.dismiss) { this.indicator.dismiss(); }
      }
      this.indicator = null;
    }
  }

}
